var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zi-more",on:{"click":_vm.toggleHandler}},[_c('zi-button',{staticClass:"zi-more-slot",attrs:{"circular":"","size":"small","loading":_vm.loading}},[_vm._v(_vm._s(_vm.statusText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }